import { extractArrayPayload, getApiErrorMessage } from "../utils/apierror";
import { BaseService } from "./BaseService";

const formatIndexDate = (value) => (value ? new Date(value).toLocaleDateString("en-US") : "");

export class IndexService extends BaseService {
  async fetchIndexes(profileId) {
    const query = "?profileID=" + encodeURIComponent(profileId || "");
    const excelPath = this.APICONFIG.GETPMEINDEX;
    try {
      return this.normalizeIndexes(await super.invokeGet(this.APICONFIG.APIBASEURL + excelPath + query));
    } catch (error) {
      const fallbackPath = String(excelPath || "").replace(/\/excel\.json$/i, "");
      if (error?.status !== 404 || !fallbackPath || fallbackPath === excelPath) {
        throw error;
      }
      return this.normalizeIndexes(await super.invokeGet(this.APICONFIG.APIBASEURL + fallbackPath + query));
    }
  }

  async getIndexes(profileId) {
    const items = await this.fetchIndexes(profileId);
    return items.map((item) => ({
      ...item,
      minBenchmarkDate: formatIndexDate(item.minBenchmarkDate),
      maxBenchmarkDate: formatIndexDate(item.maxBenchmarkDate),
    }));
  }

  normalizeIndexes(result) {
    const items = extractArrayPayload(result);
    if (!items) {
      throw new Error(getApiErrorMessage(result, "Unable to download Indexes. Please try again."));
    }

    return items.map((item) => ({
      ...item,
      benchmarkID: item.benchmarkID ?? item.indexID,
      benchmarkName: item.benchmarkName ?? item.indexName,
      minBenchmarkDate: item.minBenchmarkDate ?? item.indexValueStartDate,
      maxBenchmarkDate: item.maxBenchmarkDate ?? item.indexValueEndDate,
      burgissManaged: item.burgissManaged ?? item.isBurgissManaged,
      universeAnalyticsEligible: item.universeAnalyticsEligible ?? item.isUniverseAnalyticsEligible,
      useWithUniverseAnalytics: item.useWithUniverseAnalytics,
    }));
  }
}
